import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DataGrid, { Column, Pager, Paging, Scrolling } from 'devextreme-react/data-grid';

interface ShowModalProps {
    show: boolean;
    onClose: () => void;
    data: any[];
}

const ShowModal: React.FC<ShowModalProps> = ({ show, onClose, data }) => {
    const dataSource = Array.isArray(data) ? data : [];

    return (
        <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Sales Order Item Details</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <DataGrid
                    dataSource={dataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    rowAlternationEnabled={true}
                    onContentReady={(e) => {
                        const hasData = e.component.totalCount() > 0;
                        e.component.option("pager.visible", hasData);
                        e.component.option("paging.visible", hasData);
                    }}
                >
                    <Scrolling
                        mode='standard'
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />

                    <Paging enabled={false} />
                    <Pager visible={false} />

                    <Column cssClass='text-center' dataField="bagNo" caption="BagNo." />
                    <Column cssClass='text-center' dataField="productPrice" caption="	Product Price" dataType='number' format='#,##0.00' />
                    <Column cssClass='text-center' dataField="deductPrice" caption="Deduct Price" dataType='number' format='#,##0.00' />
                    <Column cssClass='text-center' dataField="netWT" caption="Net Wt" dataType='number' format='#,##0.000' />
                    <Column cssClass='text-center' dataField="grossWT" caption="Gross Wt" dataType='number' format='#,##0.000' />
                    <Column cssClass='text-center' dataField="styleNo" caption="Style No" />
                </DataGrid>
            </Modal.Body>
        </Modal>
    );
};

export default ShowModal;
